import { unionBy } from "lodash-es/array";
import * as Actions from "./actions";
import {
    AnalysisSetState
} from "./interfaces/state";
import { CoughAnalysisSetsFixedCommentsDisplay } from "../../misc/api/apiTypes";

export default function analysisSetReducer(state: AnalysisSetState = null, action: Actions.Action): AnalysisSetState {
    switch (action.type) {
        case Actions.ActionType.ReceiveCoughAnalysisSets:
            let newSets = action.sets.map(set => {
                return { ...set, IsSelected: false } as CoughAnalysisSetsFixedCommentsDisplay;
            });

            let sets: CoughAnalysisSetsFixedCommentsDisplay[] = unionBy(state.coughAnalysisSets, newSets, "Id");

            sets = sets.map(set => {
                return set.Id === state.primaryAnalystSetId ? { ...set, IsSelected: true } : set;
            });

            return {
                ...state,
                coughAnalysisSets: sets
            };
        case Actions.ActionType.OpenAnalysisSetDialog:
            return {
                ...state,
                isAnalysisSetDialogOpen: true
            };
        case Actions.ActionType.CloseAnalysisSetDialog:
            return {
                ...state,
                isAnalysisSetDialogOpen: false
            };
        case Actions.ActionType.ToggleAnalysisSet:
            var newCollection = state.coughAnalysisSets.map(
                set => (set.Id === action.setId ? { ...set, IsSelected: action.checked } : set)
            );
            return {
                ...state,
                coughAnalysisSets: newCollection
            };
        case Actions.ActionType.ToggleFixedComment:
            //Toggling a fixed comment means that the comment is checked/unchecked for a specific analysis set.
            var updatedCoughAnalysisStates = state.coughAnalysisSets.map(set => {
                if (set.Id == action.analysisSetId) {
                    //If the analysis set matches, then either add or remove the comment ID depending on whether the
                    //Option is checked or not.
                    if (action.checked) {
                        if (!set.FixedCommentIds.includes(action.commentId)) {
                            set.FixedCommentIds = Array.from(set.FixedCommentIds);
                            set.FixedCommentIds.push(action.commentId);
                        }
                    } else {
                        set.FixedCommentIds = set.FixedCommentIds.filter(fixedCommentId => {
                            return fixedCommentId != action.commentId;
                        });
                    }
                }

                return set;
            });

            return {
                ...state,
                coughAnalysisSets: updatedCoughAnalysisStates
            };
        case Actions.ActionType.ShowMaximumAnalysisSetsAlert:
            return {
                ...state,
                isMaximumAnalysisSetsAlertVisible: true
            };
        case Actions.ActionType.HideMaximumAnalysisSetsAlert:
            return {
                ...state,
                isMaximumAnalysisSetsAlertVisible: false
            };
        default:
            return state;
    }
}
